import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Fog"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.3717 9.837C18.6882 6.3051 15.5974 3.75303 12 3.75V5.25C14.8778 5.25386 17.35 7.2948 17.8988 10.1198L18.093 11.1292L19.1047 11.313C21.2045 11.6931 22.6681 13.6113 22.4802 15.7369C22.2923 17.8625 20.5149 19.4942 18.381 19.5H12V21H18.381C21.2911 20.9937 23.7162 18.7693 23.9732 15.8706C24.2303 12.9718 22.2346 10.3554 19.371 9.837H19.3717ZM6 18H10.5V19.5H6V18ZM3 18H4.5V19.5H3V18ZM4.5 15H10.5V16.5H4.5V15ZM1.5 15H3V16.5H1.5V15ZM6 12H10.5V13.5H6V12ZM3 12H4.5V13.5H3V12ZM7.5 9H10.5V10.5H7.5V9ZM4.5 9H6V10.5H4.5V9ZM9 6H10.5V7.5H9V6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Fog.vue"]]);
